var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Circle, Group, Text } from "../react-konva";
import { SEAT_RADIUS } from "../util";
export var Seat = function (_a) {
    var seatData = _a.seatData, priceBandData = _a.priceBandData, onDeselect = _a.onDeselect, onSelect = _a.onSelect, selectedColour = _a.selectedColour, state = _a.state;
    var colourMap = {
        available: priceBandData.color,
        selected: selectedColour,
        error: "#e63523",
        pending: selectedColour,
        unavailable: "#e2e2e2"
    };
    var handleOnSelect = function (e) {
        switch (state) {
            case 'available':
                onSelect(seatData.id, e.target.getAbsolutePosition());
                break;
            case 'selected':
            case 'error':
                onDeselect(seatData.id);
                break;
        }
    };
    var handleMouse = function (handle) { return function (e) {
        var _a, _b;
        e.target._clearCache();
        var container = (_b = (_a = e.target.getStage()) === null || _a === void 0 ? void 0 : _a.container()) !== null && _b !== void 0 ? _b : null;
        if (!container)
            return;
        if (handle === "leave") {
            container.style.cursor = "";
        }
        else {
            switch (state) {
                case 'available':
                case 'selected':
                case 'error':
                    container.style.cursor = "pointer";
                    break;
                case 'unavailable':
                case 'pending':
                    container.style.cursor = "not-allowed";
                    break;
            }
        }
    }; };
    return (_jsxs(Group, __assign({ x: seatData.x, y: seatData.y, onMouseEnter: handleMouse("enter"), onMouseLeave: handleMouse("leave"), onClick: handleOnSelect, onTap: handleOnSelect }, { children: [_jsx(Circle, { radius: SEAT_RADIUS, strokeWidth: 0.5, fill: colourMap[state], stroke: colourMap[state] == "#e2e2e2" ? '' : priceBandData.color }), state === 'error' && (_jsx(Text, { text: "!", x: -0.5, y: -1.3, fontSize: 3.6 }))] })));
};
